import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { Filter } from "src/components/shared-components/class/general-classes/filter";
import { ConvertObjectToMapFormatPipe } from "src/pipes/convert-object-to-map-format.pipe";

@Component({
    selector: "app-filter-alarms-history",
    styleUrls: ["./filter-alarms-history.component.scss"],
    templateUrl: "./filter-alarms-history.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterAlarmsHistoryComponent implements OnInit {
  public filterAlarmsHistoryResultForm: UntypedFormGroup = null;

  @Input("alarmsHistoryListFilters") alarmsHistoryListFilters: Filter[];
  @Output() submitFilters = new EventEmitter<void>();
  public filteredEnvironments: any[] = [];

  constructor(
    private _fb: UntypedFormBuilder,
    private _convertObjectToMapFormatPipe: ConvertObjectToMapFormatPipe,
  ) {}

  ngOnInit(): void {
    this.initializeFormFilterAlarmsHistory();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.alarmsHistoryListFilters && this.alarmsHistoryListFilters) {
      this.filteredEnvironments =
        this.alarmsHistoryListFilters[3]?.Values || [];
    }
  }

  /**
   * Handles the collecting of the alarms history filtered values and return them to the required format
   * @returns mapResult: this is the filtered data in form of the required Map<string,string> format
   */
  public onFilterAlarmsHistoryList(): Map<string, string> {
    const filterFormVals = { ...this.filterAlarmsHistoryResultForm.value };

    if (
      filterFormVals.idEnvironment &&
      typeof filterFormVals.idEnvironment === "object"
    ) {
      filterFormVals.idEnvironment = filterFormVals.idEnvironment.Id;
    }

    const mapResultFormValsMapResult: Map<string, string> =
      this._convertObjectToMapFormatPipe.transform(filterFormVals);

    return mapResultFormValsMapResult;
  }

  /**
   * Remove the building part filter
   */
  public onClickClearEnvironment(): void {
    this.filterAlarmsHistoryResultForm.get("idEnvironment").setValue("");
  }

  /**
   * Restore the default filter values (last day, no name, all building parts)
   */
  public resetFilters(): void {
    this.filterAlarmsHistoryResultForm.reset(
      this.generateFilterAlarmsHistoryFormDefaultValues().value,
    );
  }

  /**
   * Dynamically generate the form controls and also the initial values for initialization
   * @returns Filter alarms FormGroup
   */
  private generateFilterAlarmsHistoryFormDefaultValues(): UntypedFormGroup {
    const filterFormControlsConfig = this.alarmsHistoryListFilters.reduce(
      (formConfigAccumulator, alarmsHistoryFilter, index) => {
        if (
          index === 6 &&
          alarmsHistoryFilter.Values &&
          alarmsHistoryFilter.Values.length > 0
        ) {
          formConfigAccumulator[alarmsHistoryFilter.Name] = [
            alarmsHistoryFilter.Values[0]?.Id || "",
          ];
        } else {
          formConfigAccumulator[alarmsHistoryFilter.Name] = [
            alarmsHistoryFilter.InputValue !== undefined
              ? alarmsHistoryFilter.InputValue
              : "",
          ];
        }

        return formConfigAccumulator;
      },
      {},
    );

    // This creates the form group with the dynamically generated form controls, incase the  Filter[] changes in the future
    return this._fb.group(filterFormControlsConfig);
  }

  /**
   * Handle the initialization of the filter form field
   */
  private initializeFormFilterAlarmsHistory(): void {
    this.filterAlarmsHistoryResultForm =
      this.generateFilterAlarmsHistoryFormDefaultValues();
  }
}
